import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Edit_svg__a)">
      <path
        d="m2.273 10.625 8.76-8.76a2.2 2.2 0 0 1 3.124-.021 2.197 2.197 0 0 1-.022 3.123l-8.76 8.76-4.172 1.07zm0 0 3.105 3.099m5.14-11.343 3.101 3.102"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Edit_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEdit;
